module.exports = __webpack_public_path__ + "img/GH-corporate-003.c032542c.png";